import { getRoleName, getUserName } from "App/utils/cookies";
import React, { useEffect, useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { ListItemIcon, Typography, withStyles } from "@material-ui/core";
import { ExitToApp, PersonAdd } from "@material-ui/icons";
import ModalLogout from "./ModalLogout";
import { instanceEmrV2Akses } from "App/constants";
import { defaultToastError } from "App/utils/helpers";
import ModalPilihAplikasi from "./ModalPilihAplikasi";

function UserInformationSso() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [apps, setApps] = useState([]);

  const getApps = async () => {
    try {
      const response = await instanceEmrV2Akses.get("/user/get-app-by-user");
      if (response.data.status === 200) {
        setApps(response.data.data.list);
      } else {
        defaultToastError(response.data.message);
        setApps([]);
      }
    } catch (error) {
      setApps([]);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    getApps();
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "0 0.5rem",
        }}>
        <div className='text-right'>
          <p
            style={{
              color: "black",
              fontSize: "12px",
              textTransform: "uppercase",
              fontWeight: "600",
            }}>
            {getUserName()}
          </p>
          <p
            className='text-xxs'
            style={{
              color: "black",
              fontSize: "10px",
              marginTop: "-5px",
            }}>
            {getRoleName() || "Role User"}
          </p>
        </div>

        <div
          onClick={handleClick}
          style={{
            cursor: "pointer",
          }}>
          <img
            src={`${window.location.origin}/images/user.png`}
            alt='User Logo'
            width='25px'
          />
        </div>
      </div>

      <MenuAccount anchorEl={anchorEl} handleClose={handleClose} apps={apps} />
    </>
  );
}

const StyledMenuItem = withStyles((theme) => ({
  root: {
    fontSize: "14px",
  },
}))(MenuItem);

function MenuAccount({ anchorEl, handleClose, apps }) {
  const [showModalLogout, setShowModalLogout] = useState(false);

  const handleClickLogout = () => {
    setShowModalLogout(!showModalLogout);
    handleClose();
  };

  const [open, setOpen] = React.useState(false);

  const handleOpenPilihAplikasi = () => {
    setOpen(true);
    handleClose();
  };

  const handleClosePilihAplikasi = () => {
    setOpen(false);
  };

  return (
    <>
      {showModalLogout && (
        <ModalLogout setShowModal={() => setShowModalLogout(false)} />
      )}

      <ModalPilihAplikasi
        apps={apps}
        open={open}
        handleClose={handleClosePilihAplikasi}
      />

      <Menu
        anchorEl={anchorEl}
        keepMounted
        elevation={0}
        open={Boolean(anchorEl)}
        onClose={handleClose}>
        <StyledMenuItem onClick={() => handleOpenPilihAplikasi()}>
          <ListItemIcon
            style={{
              minWidth: "40px",
            }}>
            <PersonAdd fontSize='small' />
          </ListItemIcon>
          <Typography variant='inherit'>Pindah Aplikasi</Typography>
        </StyledMenuItem>
        <StyledMenuItem onClick={() => handleClickLogout()}>
          <ListItemIcon
            style={{
              minWidth: "40px",
            }}>
            <ExitToApp fontSize='small' />
          </ListItemIcon>
          <Typography variant='inherit'>Keluar</Typography>
        </StyledMenuItem>
      </Menu>
    </>
  );
}

export default UserInformationSso;
